import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import useRecruiterDashboard from './useRecruiterDashboard';
import BarChartCommonComponent from '../../../../library/SimpleControls/BarChartCommonComponent';

const PotentialRecruitersBar = () => {
    const { state } = useContext(SmartContext);
    const { getPotentialRecruitersBarData } = useRecruiterDashboard();

    useEffect(() => {
        getPotentialRecruitersBarData();
    }, [state.data.searchCriteria.potentialRecruitersBar]);

    if (isEmpty(state.data?.reportData?.potentialRecruitersBar)) 
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state.data.reportData.potentialRecruitersBar} />
        </>
    );
};

export default PotentialRecruitersBar;
